import React from 'react'
import ProductsOriginalConnector, {
  ConnectorProps as ProductsOriginalProps,
} from '../../../connectors/ProductsOriginal'
import ForSale from './ForSale'
import NotForSale from './NotForSale'
import Packaging from './Packaging'
import Reserved from './Reserved'
import SoldOut from './SoldOut'
import { BlackBox } from '../../styles/products'
import { ARTWORK } from '../../../helpers/constants'
import DiscountBanner from './DiscountBanner'

const ProductsOriginal = (props: ProductsOriginalProps) => {
  const { productType, productStatus } = props

  if (productType !== ARTWORK) {
    return null
  }

  return (
    <>
      <Packaging />

      <DiscountBanner />

      <BlackBox data-type='original' data-status={productStatus}>
        <ForSale />
        <NotForSale />
        <Reserved />
        <SoldOut />
      </BlackBox>
    </>
  )
}
export default ProductsOriginalConnector(ProductsOriginal)
